import React,{ Component } from 'react';
import SolarPanel from '../image/sp.png';
import '../style/DraggablePanel.css';
import PanelImage from './PanelImage';


class DraggablePanel extends Component{
    constructor(props){
        super(props);
        this.state={
            imagelist:[],
            panelNumber : this.props.panelNumber,
            rotation:0,
            inclination: 0,
            mountType: null,
            ACPower : null,
        }
    }
    //deal with the drag x and y
    componentWillReceiveProps(nextProp) {
        if (this.props.number !== nextProp.number) {
             var realNumber = nextProp.number;
             realNumber = realNumber / 300;
            this.loadImage(realNumber);
        }
    }

    componentDidMount(){
        var realNumber = this.props.number / 300;
        this.loadImage(realNumber);
    }

    loadImage(realNumber){
        var imageArr = [];
        for(let i = 0; i < realNumber; i++){
            imageArr.push( {
                src:SolarPanel,
                key:i
            });
        }
        this.setState({
          imagelist: imageArr
        });
    }

    transeRotation = (inputRotation) =>{
        this.setState({
            rotation: inputRotation
        })
    }

    transeMountType = (inputMountType) => {
        this.setState({
            mountType : inputMountType
        })
    }

    transeInclination = (inputInclination) => {
        this.setState({
            inclination : inputInclination
        })
    }

    transeACPower = (inputACPower)=>{
        this.setState({
            ACPower : inputACPower
        })
    }

    imageOnClick = (key, e) =>{
        this.setState({
            panelNumber : key,
            rotation: localStorage.getItem('rotation'+this.props.panelnumber) ? localStorage.getItem('rotation'+this.props.panelnumber) : 0,
            inclination: localStorage.getItem('inclination'+this.props.panelnumber) ? localStorage.getItem('inclination'+this.props.panelnumber) : 0,
            mountType: localStorage.getItem('mountType'+this.props.panelnumber) ? localStorage.getItem('mountType'+this.props.panelnumber) : null,
        }, () => {
            this.props.onSelectPanel(key);
        });
    }
    //allow user to click number to chose panel
    numberOnClick = (key) => {
        this.setState({
            panelNumber : key,
            rotation: localStorage.getItem('rotation'+this.props.panelnumber) ? localStorage.getItem('rotation'+this.props.panelnumber) : 0,
            inclination: localStorage.getItem('inclination'+this.props.panelnumber) ? localStorage.getItem('inclination'+this.props.panelnumber) : 0,
            mountType: localStorage.getItem('mountType'+this.props.panelnumber) ? localStorage.getItem('mountType'+this.props.panelnumber) : null,
        }, () => {
            this.props.onSelectPanel(key);
        });
    }

    componentDidUpdate(){
        // console.log("data update");
        // localStorage.setItem(this.state.panelNumber+"rotation",this.state.rotation);
        // localStorage.setItem(this.state.panelNumber+"inclination",this.state.inclination);
        // localStorage.setItem(this.state.panelNumber+"mountType",this.state.mountType);
    }

    renderImageList(){

        return(
        this.state.imagelist.map((imagelist) => {
            const rotation = localStorage.getItem('rotation'+imagelist.key) ? localStorage.getItem('rotation'+imagelist.key) : 0;
            const inclination = localStorage.getItem('inclination'+imagelist.key) ? localStorage.getItem('inclination'+imagelist.key) : 0;
            const mountType = localStorage.getItem('mountType'+imagelist.key) ? localStorage.getItem('mountType'+imagelist.key) : null;
            return (
              <PanelImage
                key={imagelist.key}
                imagelist={imagelist}
                selected={this.state.panelNumber}
                panelNumber = {imagelist.key}
                imageOnClick={ this.imageOnClick}
                numberOnClick={this.numberOnClick}
                panelRotation = {rotation}
                panelInclination ={inclination}
                panelMountType ={mountType}
              />
              )
          }

        ));
    }


    render(){
        return (
                <div className='PositionPanelSpace'>
                    <div className="row">
                                <div className="col-sm-10 offset-sm-1 col-md-10 offset-md-1  col-lg-10 offset-lg-1 text-left">
                                    {this.renderImageList()}
                                    <div className="head">Drag panels into place. Each set takes 58.4 x 53.5 inches.</div>

                                </div>

                    </div>
                </div>
        )
    }
}

export default DraggablePanel;



// WEBPACK FOOTER //
// ./src/components/DraggablePanel.js